import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import RodapeFeiras from '@alweb-merkator/shared/components/RodapeFeiras';

function Rodape() {
  const { t } = useTranslation();
  const { lang } = useParams();

  const item = (text, link, subMenus = [], externalLink = false) => ({
    text: text,
    link: link,
    subMenus,
    externalLink,
  });

  const medias = {
    appStore: '//apps.apple.com/us/app/merkator-feiras-e-eventos/id1487335018',
    googlePlay:
      '//play.google.com/store/apps/details?id=com.ricardoaguiar.appmerkatorexpo',
  };

  const linksSobreAFeira = useMemo(
    () => [
      item(t('cabecalho.sobreAFeira'), `/${lang}#${t('slugs.feira')}`),
      item(t('cabecalho.feira'), `/${lang}#${t('slugs.feira')}`),
      item(t('cabecalho.novoHamburgo'), `/${lang}#${t('slugs.novoHamburgo')}`),
      item(t('cabecalho.fenac'), `/${lang}#${t('slugs.fenac')}`),
      item(t('cabecalho.parceiros'), `/${lang}#${t('slugs.parceiros')}`),
      item(
        t('cabecalho.grupoDeImportadores'),
        `/${lang}#${t('slugs.grupoDeImportadores')}`
      ),
    ],
    []
  );

  return <RodapeFeiras linksSobreAFeira={linksSobreAFeira} medias={medias} />;
}

export default Rodape;
